 export const getEnv = (key, fallback = null) => {
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }


  const buildTimeKey = `REACT_APP_${key}`;
  if (process.env[buildTimeKey] !== undefined) {
    return process.env[buildTimeKey];
  }


  return fallback;
};